import EventEmitter from "base/EventEmitter";

class ProxiedEventEmitter extends EventEmitter {

    constructor(fn) {
        super();

        this.fn = fn;
    }

    emit(name, eventData = {}) {
        let data = {
            name: name,
            data: eventData
        };

        try {
            this.fn.call(this, data);
        } catch (e) {
            console.error("Couldn't call event modifier", name, eventData, e);
        }

        return super.emit(data.name, data.data);
    }

}

export default ProxiedEventEmitter;
